import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { useContext, useState } from 'react'
import { Input } from '@material-tailwind/react'
import { NewContractContext } from './context'
import { CompanySelector, ContractSelector, MultiOfficeSelector } from '@/shared/selectors'
import { toOptions } from '@/utils'

export const GeneralInformationForm = () => {
  const { currentContract, selectedOffices } =
    useContext(NewContractContext)
  console.log({ selectedOffices })
  const { t } = useTranslation()
  const { values, handleChange, setFieldValue } = useFormikContext()
  const [currentCompany, setCurrentCompany] = useState(
    currentContract?.company || {}
  )

  // handlers
  const handleCompanyChange = ({ value, resource }) => {
    setFieldValue('contractor_company_id', value)
    setCurrentCompany(resource)
  }

  const handleOfficeChange = (options) => {
    setFieldValue('office_ids', options.map(option => option?.value))
  }

  return (
    <>
      <div className='grid grid-cols-3 gap-5'>
        <Input
          required
          label={t('contract.one')}
          name="name"
          value={values.name}
          onChange={handleChange}
        />

        <CompanySelector
          value={values.contractor_company_id}
          onChange={handleCompanyChange}
          required
        />

        {
          currentContract?.id &&
          <ContractSelector
            reduceOptions={(_, curr) => curr.filter(opt => opt.value !== currentContract.id)}
            onChange={(opt = {}) => setFieldValue('ancestry', opt?.value ? String(opt?.value) : null)}
            value={Number(values.ancestry)}
            label="Contrato padre"
          />
        }
      </div>

      <div className='grid grid-cols-2 gap-5'>

        <Input
          label={t('common.serviceType')}
          required
          readOnly
          value={currentCompany?.serviceType?.name || ''}
        />

        <MultiOfficeSelector
          required
          value={values.office_ids}
          onChange={handleOfficeChange}
        />

        <Input
          required
          type="date"
          label={t('common.startDate.of', {
            what: t('contract.one').toLowerCase()
          })}
          name="start_date"
          value={values.start_date}
          onChange={handleChange}
        />
        <Input
          required
          type="date"
          label={t('common.finishDate.of', {
            what: t('contract.one').toLowerCase()
          })}
          name="finish_date"
          value={values.finish_date}
          onChange={handleChange}
        />

      </div>
    </>
  )
}
